

















import EpisodeTitle from '@/views/templates/kuntama/parts/EpisodeTitle.vue'
import Episode8Item from '@/views/templates/kuntama/parts/Episode8Item.vue'

export default
  components: {
    EpisodeTitle
    Episode8Item
  }

  data: () ->
    messages: [
      [
        'スーさん、“燻らのたまご”の魅力をたくさん知ってくれてありがとう！燻製のことは、よくわかってくれたと思うので、次は原料のたまごのことを紹介するね。'
      ]
      [
        '桑野さん、ありがとう！うん、原料のたまごのことも教えて！教えて！'
      ]
      [
        'たまごはね、栄養価の高さとバランスの良さから「完全栄養食品」と呼ばれるほど、すべての栄養素（ビタミンCと食物繊維以外）を含んでいるんだよ！'
      ]
      [
        'へーーーっ！！ちっとも知らなかった！'
      ]
      [
        'それに、たまごはごはんやお肉、野菜との相性も抜群だよね！なので、たまごに含まれていないビタミンCや食物繊維の栄養素は、野菜や果物と一緒に食べるとうまく摂取できるんだよ！'
      ]
      [
        'す、すごいんだね！たまごって！'
        'おいしいうえに、バランス良く栄養が摂れるだなんて！！'
        'まさに「完全栄養食品」だね！'
      ]
    ]
